import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseRadio = _resolveComponent("BaseRadio")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('booking.tripDetails.route.title')), 1),
    (_ctx.modeOfTravel !== _ctx.ModeOfTravelEnum.FlyAndSail && _ctx.modeOfTravel !== _ctx.ModeOfTravelEnum.SailAndFly)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tripTypes, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: option.value
            }, [
              (_openBlock(), _createBlock(_component_BaseRadio, {
                name: option.name,
                id: option.name,
                key: option.name,
                label: option.label,
                value: option.value,
                modelValue: _ctx.tripType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tripType) = $event))
              }, null, 8, ["name", "id", "label", "value", "modelValue"]))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}